module.exports = "/images/extra-equipment.svg?e8cc437b9e0e8cc96bde3d90c8f825f2";